<template>
  <div>
    <span v-if="editing">
      <input type="text" class="form-control d-inline" v-model="fileName" @blur="blur" @focus="focus"  v-on:keyup.enter="blur" />
    </span>
    <span v-else>
      <div class="float-left">
        <i class="material-icons">attach_file</i>
        <span v-html="fileNameContent()" @mousedown="focus"></span>
        <div class="modal fade" :id="'deleteFileModal' + file.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to delete this attachment?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to delete? -
                  <em>
                    {{file.filename}}
                  </em>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" @click="deleteFile">Delete Attachment</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="float-right">
        <a :href="fileUrl()" target="_blank" class="pointer text-secondary"><i class="material-icons">open_in_new</i></a>
        <i class="material-icons pointer" data-toggle="modal" :data-target="'#deleteFileModal' + file.id">delete_forever</i>
      </div>
    </span>
  </div>
</template>

<script>
import api from "api";

export default {
  components: {
  },
  data() {
    return {
      editing: false,
      fileName: this.file.filename,
    };
  },
  props: {
    file: {
      type: Object
    },
    task: {
      type: Object
    }
  },
  methods: {
    saveFilename(){
      if(this.fileName != this.file.filename){
        api.updateAttachment(this.task.id, { file_id: this.file.id, title: this.fileName }).then(response => {
          this.editing=false
        });
      } else {
        this.editing=false;
      }
    },
    fileNameContent(){
      return this.fileName
    },
    deleteFile() {
      api.deleteAttachment(this.task.id, this.file.id).then(response => {
        $('#deleteFileModal' + this.file.id).modal('hide');
        $('body').removeClass('modal-open');
        $(".modal-backdrop").hide();
      });
    },
    blur(){
      this.saveFilename()
    },
    focus(){
      this.editing = true;
    },
    fileUrl(){
      return '/api/tasks/' + this.task.id + '/fetch_attachment.json?file_id=' + this.file.id;
    },
  }
}
</script>
